import { LoginConfig, UnRecordTrajectoryConfig, ErrorConfig, PhysicalLeaderConfig } from '@/common/utils/login-config';
import self from '@/common/utils/global-config';
import * as Constants from '@/common/utils/constants';
import * as Messages from '@/common/utils/messages';
import * as Initial from '@/common/utils/initial';
import * as Tools from '@/common/utils/tools';

export async function interceptor(to, from, next, login, func = [], title) {
  const entry = self.$sn.utils.getSessionStorage('InitialEntryPage') || 'true';
  self.$sn.utils.setSessionStorage('InitialEntryPage', 'false', false);
  if (entry !== 'true' && to.path === from.path) {
    next(false);
    return;
  }
  if (!UnRecordTrajectoryConfig.includes(to.path)) {
    self.$sn.utils.setHospitalSessionStorage('CurrentTrajectory', {
      params: to.params,
      path: to.path,
      querty: to.query
    });
  }
  // 处理当前医院是否可用
  if (entry === 'true') {
    self.$sn.assembly.loading(true);
    try {
      await Initial.initialHospitalInformation();
      self.$sn.assembly.loading(false);
    }
    catch (error) {
      self.$sn.assembly.loading(false);
      Tools.removeEntireInformation();
      // 服务升级公告-为了给您提供更优质的服务，我们正在实施系统升级，期间本系统功能将不可使用。因此给您带来的不便，我们深表歉意，并将尽快恢复对您的服务。
      self.$sn.utils.setHospitalSessionStorage('Homepage_ErrorCaption', {
        title: Messages.C010,
        caption: Messages.C011
      });
      next(ErrorConfig);
      return;
    }
  }
  if (Initial.verifyHospitalInformation()) {
    if (self.$sn.utils.getLoginCondition()) {
      if (entry === 'true') {
        self.$sn.assembly.loading(true);
        try {
          await Initial.suffixLogin();
        }
        catch (error) {}
        self.$sn.assembly.loading(false);
      }
      // 山东省立医院-仅允许团体体检负责人访问登记与团约页面
      if (PhysicalLeaderConfig.includes(to.path)) {
        const user = self.$sn.vuex.get('vuex_login_user.' + self.$sn.utils.getHospitalId());
        if (user.leader && user.leader === '1') navigate(to, from, next, login, func, title);
        else {
          // 温馨提示-该功能暂未开通
          self.$sn.utils.setHospitalSessionStorage('Homepage_ErrorCaption', {
            title: Messages.C029,
            caption: Messages.C030
          });
          next(ErrorConfig);
        }
      }
      else navigate(to, from, next, login, func, title);
    }
    else {
      if (login === Constants.LOGIN_TYPE_LOGIN) {
        if (from.path === LoginConfig) {
          next(false);
          return false;
        }
        next(LoginConfig);
      }
      else navigate(to, from, next, login, func, title);
    }
  }
  else {
    Tools.removeEntireInformation();
    // 服务升级公告-为了给您提供更优质的服务，我们正在实施系统升级，期间本系统功能将不可使用。因此给您带来的不便，我们深表歉意，并将尽快恢复对您的服务。
    self.$sn.utils.setHospitalSessionStorage('Homepage_ErrorCaption', {
      title: Messages.C010,
      caption: Messages.C011
    });
    next(ErrorConfig);
  }
}

async function navigate(to, from, next, login, func = [], title) {
  const file = to.path.split('/')[1];
  const config = Constants.CONFIG_COMPARE[file] || [];
  if (func.length > 0) {
    func.forEach(el => {
      if (!config.includes(el)) config.push(el);
    });
  }
  if (config.length > 0) {
    self.$sn.assembly.loading(true);
    try {
      await Tools.getHospitalConfigInformation(config);
    }
    catch (error) {}
    self.$sn.assembly.loading(false);
  }
  to.meta.title = title || self.$sn.utils.getHospitalTitle();
  document.title = to.meta.title;
  next();
}
